import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import StudentTrackerComponent from './StudentTrackerComponent';

const StudentTracker = () => {
  return renderComponent(<StudentTrackerComponent />);
};

export default StudentTracker;
